import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./pages/Dashboard";
import DashboardV2 from "./pages/Dashboard-v2";
// import UserManagement from "./pages/UserManagement";
import UserManagement from "./pages/UserManagementV2";
import UserViewer from "./pages/UserViewer";
import UserDetail from "./pages/UserDetail";
import Login from "./pages/Login";
import ActivateAccount from "./pages/ActivateAccount";
import SidebarLayout from "./components/SidebarLayout";
import FacilityListPage from "./v2/facility/pages/FacilityListPage";
import FacilityDetailPage from "./v2/facility/pages/FacilityDetailPage";
import ProtectedRoute from "./core/ProtectedRoute";
import OrgCollection from "./pages/OrgCollection";
import { CollectionDetail } from "./components/CollectionDetail";
import { CollectionProvider } from "./contexts/CollectionContext";
import { FacilityTheme } from "./pages/FacilityTheme";
import { FacilityAbout } from "./pages/FacilityAbout";
import AddFacility from "./pages/AddFacility";
import RoleProtectedRoute from "./core/RoleProtectedRoute";
import Unauthorized from "./pages/Unauthorized";
import { userRoles } from "./helpers/constant";
import AutoLogOffModal from "./components/autoLogOffModal";
import { initLogoutListener } from "./services/azurePubsubHandler";
import { decodeAccessToken } from "./helpers/helpers";
import { useDashboardUI } from "./context/GlobalContext";
import { PromptManagement } from "./pages/PromptManagement";
import FeedbackManagement from "./pages/FeedbackManagement";
import SupportTickets from "./pages/SupportTickets";
import Campaigns from "./pages/Campaigns";
import CampaignDetail from "./pages/CampaignDetail";
import AuthorizePage from "./pages/Authorize";
import { AssistantList } from "./pages/assistants/AssistantList";
import CreateUpdateAssistant from "./pages/assistants/CreateAssistant";
import AssistantFileList from "./pages/assistants/AssistantFileList";
import Notifications from "./pages/Notifications";
import ChatCategories from "./pages/ChatCategories";
import NotificationDetail from "./pages/NotificationDetail";


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const { showForcedLogout, setShowForcedLogout } = useDashboardUI();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const isAuthenticatedValue = !!token;
    setIsAuthenticated(isAuthenticatedValue);
    if(isAuthenticatedValue){
      initLogoutListener(localStorage.getItem("unique_session_id") || decodeAccessToken()?.unique_session_id, setShowForcedLogout)
    }
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="h-screen flex items-center justify-center text-gray-500">
        Loading...
      </div>
    );
  }

  return (
    <CollectionProvider>
      <Routes>
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
        />

        {/* Authorize Page */}
        <Route
          path="/authorize"
          element={
              <AuthorizePage />
          }
        />

        <Route path="/activate/:userId" element={<ActivateAccount />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
          <Route element={<SidebarLayout />}>
            <Route index element={<DashboardV2 />} />
            <Route path="/user-management" element={<UserManagement />} />
            {/* <Route path="/dashboard-v2" element={<DashboardV2 />} /> */}
            <Route path="/prompt-management" element={<PromptManagement />} />
            <Route path="/users/:userId" element={<UserDetail />} />
            {/* <Route path="/users/:userId/chats" element={<UserViewer />} /> */}
            
            /* Superadmin only routes */
            <Route element={<RoleProtectedRoute allowedRoles={[userRoles.SUPERADMIN]} />}>
              <Route path="/addFacility" element={<AddFacility />} />
              <Route path="/facility" element={<FacilityListPage />} />
              <Route path="/facility/:id" element={<FacilityDetailPage />} />
              <Route path="/org-collection" element={<OrgCollection />} />
              <Route path="/collections/:id" element={<CollectionDetail />} />
              <Route
              path="/collections/:collectionId/files/:fileId"
              element={
                <div className="p-8 text-lg">File Preview Page (stub)</div>
              }
              
            />
            <Route path="/editFacility/:facilityId" element={<AddFacility />} />
            <Route path="/editFacilityTheme/:facilityNumber" element={<FacilityTheme />} />
            <Route path="/about-me/:facilityNumber" element={<FacilityAbout />} />
            <Route path="/about-me/global" element={<FacilityAbout />} />
            
            <Route path="/assistants" element={<AssistantList />} />
            <Route path="/chat-categories" element={<ChatCategories />} />
            <Route path="/create-assistant" element={<CreateUpdateAssistant />} />
            <Route path="/update-assistant/:assistantId" element={<CreateUpdateAssistant />} />
            <Route path="/update-assistant-files/:assistantId" element={<AssistantFileList />} />
            <Route
              path="/campaigns"
              element={<Campaigns />}
            />
            <Route
              path="/campaigns/:campaignId"
              element={<CampaignDetail />}
            />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/notifications/:notificationId" element={<NotificationDetail />} />
            </Route>

            
            <Route
              path="/feedback-management"
              element={<FeedbackManagement />}
            />

            <Route
              path="/support-tickets"
              element={<SupportTickets />}
            />


          </Route>
        </Route>
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* Catch-all */}
        <Route
          path="*"
          element={<Navigate to={isAuthenticated ? "/" : "/login"} replace />}
        />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <AutoLogOffModal show={showForcedLogout} onClose={() => setShowForcedLogout(false)} />
    </CollectionProvider>
  );
}

export default App;
